import { deflateSync, inflateSync, strToU8, strFromU8 } from 'fflate';

const COOKIE_COMPRESS_PREFIX = 'sclen:';

function _compress(str) {
  const compressed = deflateSync(strToU8(str));
  let binary = '';
  for (let i = 0; i < compressed.length; i++) {
    binary += String.fromCharCode(compressed[i]);
  }
  return COOKIE_COMPRESS_PREFIX + btoa(binary);
}

function _decompress(value) {
  if (!value.startsWith(COOKIE_COMPRESS_PREFIX)) return value;
  const binary = atob(value.slice(COOKIE_COMPRESS_PREFIX.length));
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return strFromU8(inflateSync(bytes));
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

let _cachedUser = null;

function setCompressedCookie(cname, cvalue, exdays) {
  if (cname === 'teg-user' || cname === 'user') _cachedUser = null;
  const str = typeof cvalue === 'string' ? cvalue : JSON.stringify(cvalue);
  const compressed = _compress(str);
  const d = new Date();
  d.setTime(d.getTime() + ((exdays || 1) * 24 * 60 * 60 * 1000));
  const expires = "expires=" + d.toUTCString();
  const secureFlag = window.location.protocol === "https:" ? "Secure;" : "";
  document.cookie = `${cname}=${encodeURIComponent(compressed)};${expires};path=/;${secureFlag}SameSite=Strict;`;
}

function getCookie(cname) {
    if ((cname === 'teg-user' || cname === 'user') && _cachedUser) return _cachedUser;
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            const raw = c.substring(name.length, c.length);
            const value = raw.startsWith(COOKIE_COMPRESS_PREFIX) ? _decompress(raw) : raw;
            if (cname === 'teg-user' || cname === 'user') _cachedUser = value;
            return value;
        }
    }
    return "";
  }

  function deleteCookie(cname) {
    document.cookie = cname+"=;path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
  }




const getCookieV3 = (name) => {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    let [key, value] = cookie.split("=");
    if (key === name) {
      return JSON.parse(decodeURIComponent(value)); // Convert string back to object
    }
  }
  return null;
};
 const setCookieV3 = (cname, cvalue, exdays, domain) => {
  if (!domain) {
    domain = window.location.hostname.includes("localhost") ? "" : window.location.hostname;
  } else if (window.location.hostname.includes("localhost")) {
    domain = "";
  }
  let d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = `expires=${d.toUTCString()}`;
  let cookieString = `${cname}=${encodeURIComponent(cvalue)}; ${expires}; path=/`;
  if (domain) {
    cookieString += `; domain=${domain}`;
  }
  // Optional: Secure cookies on HTTPS
  if (window.location.protocol === "https:") {
    cookieString += "; Secure; SameSite=Lax";
  }
  document.cookie = cookieString;
};


export const getChangeToken = ()=> {
  return getCookie('change-token')  || "";
}

  export {getCookie, setCookie, setCompressedCookie, deleteCookie,
    getCookieV3,
    setCookieV3
  };
